export default "__VITE_ASSET__DReW86qK__"